'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialGooglePlusCircular = function TiSocialGooglePlusCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.3 21.8l-0.6-0.5c-0.2-0.1-0.5-0.3-0.5-0.8l0.5-1c0.8-0.7 1.6-1.3 1.6-2.8s-1-2.4-1.3-2.7h1.2l1.1-0.7h-4c-1 0-2.3 0.2-3.5 1-0.8 0.7-1.3 1.7-1.3 2.7 0 1.5 1.2 3.2 3.3 3.2h0.7c-0.2 0.1-0.2 0.3-0.2 0.6 0 0.7 0.4 1 0.7 1.4-0.8 0-2.5 0.1-3.8 0.8-1.2 0.7-1.5 1.7-1.5 2.3 0 1.5 1.3 2.9 4.1 2.9 3.4 0 5.2-1.9 5.2-3.7 0-1.2-0.8-1.8-1.7-2.7z m-2.6-2.1c-1.7 0-2.5-2.2-2.5-3.5 0.1-0.7 0.1-1.2 0.5-1.5s0.8-0.7 1.3-0.7c1.7 0 2.5 2.2 2.5 3.7 0 0.3 0 1-0.5 1.5-0.2 0.1-0.8 0.5-1.3 0.5z m0.1 7.8c-2.1 0-3.5-1-3.5-2.3 0-1.4 1.4-1.9 1.7-2 0.8-0.4 1.8-0.4 2-0.4h0.5c1.5 1 2.2 1.7 2.2 2.7 0 1.2-1 2-2.9 2z m6.2-7.5h-1.7v-1.7h1.7v-1.6h1.7v1.6h1.6v1.7h-1.6v1.7h-1.7z m-5 15c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z m0-26.7c-6.5 0-11.7 5.2-11.7 11.7s5.2 11.7 11.7 11.7 11.7-5.2 11.7-11.7-5.2-11.7-11.7-11.7z' })
        )
    );
};

exports.default = TiSocialGooglePlusCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-google-plus-circular.js
// module id = 2177
// module chunks = 0